import * as React from 'react';
import { createChatLink } from '../../utils/webim/createChatLink';
import { ChatButtonBlockMobile } from '../../components/ChatButtonBlockMobile';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * @deprecated Рекомендуется использовать NewbuildingChatButtonMobile
 */
export function NewbuildingChatMobile(_ref) {
  var accountName = _ref.accountName,
    userData = _ref.userData,
    _ref$host = _ref.host,
    host = _ref$host === void 0 ? 'webim.ru' : _ref$host,
    location = _ref.location;
  var open = React.useCallback(function () {
    var link = createChatLink({
      accountName: accountName,
      userData: userData,
      host: host,
      location: location
    });
    window.open(link, '_blank');
  }, [accountName, userData, location]);
  return /*#__PURE__*/_jsx(ChatButtonBlockMobile, {
    onClick: open
  });
}